import { EventDispatcher } from "three"

export { Timer }

class Timer extends EventDispatcher {
    #start = Date.now()
    #current = this.#start
    #delta

    #tick() {
        const currentTime = Date.now()
        this.#delta = currentTime - this.#current
        this.#current = currentTime

        this.dispatchEvent({
            type: "tick",
            currentTime,
            delta: this.#delta,
            elapsed: currentTime - this.#start,
        })

        window.requestAnimationFrame(() => this.#tick())
    }

    constructor() {
        super()
        window.requestAnimationFrame(() => this.#tick())
    }

    get delta() {
        return this.#delta
    }

    /**
     * @param {(tick?: number, clock?: Timer) => void} func that shall be called during cooldown  
     * @param {number} ticks the cooldown should last 
     * @returns {() => void} function to cancel coodown
     */
    cooldown(func, ticks = this.getCooldownFromSeconds()) {
        const initialTicks = ticks
        const cooldownFunction = () => {
            func(ticks, initialTicks, this)

            if (--ticks < 1) this.removeEventListener("tick", cooldownFunction)
        }

        this.addEventListener("tick", cooldownFunction)

        return () => this.removeEventListener("tick", cooldownFunction)
    }

    /**
     * Calculates number of ticks for the cooldown to be frame rate independend.
     * @param {number} seconds the cooldown shall last
     * @returns {number} cooldown ticks
     */
    getCooldownFromSeconds(seconds = 5) {
        return seconds * 1000 / (this.delta || 16)
    }
}